import React from "react";
import { Logo } from "./Logo";
import { DIRECTORS, NAV_LINKS, CONTACT } from "../../data/content";

export const Footer = ({ scrollTo }) => (
  <footer className="relative border-t border-brand-line bg-brand-surface/30 overflow-hidden" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr] gap-12 mb-16">
        <div>
          <Logo onClick={() => scrollTo("hero")} />
          <p className="mt-6 max-w-xs text-brand-soft font-light leading-relaxed">
            A world-class organization in human capital development and management in Africa.
          </p>
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-brand-muted">RC: 957357</p>
        </div>

        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-brand mb-6">Navigate</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <button onClick={() => scrollTo(l.id)} className="text-brand-soft hover:text-brand-text transition-colors font-light">
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-brand mb-6">Board of Directors</p>
          <ul className="space-y-3">
            {DIRECTORS.map((d) => (
              <li key={d} className="text-brand-soft font-light text-sm">{d}</li>
            ))}
          </ul>
        </div>
      </div>

      {/* Massive wordmark */}
      <div className="border-t border-brand-line pt-10">
        <h2 className="font-display font-light text-[24vw] leading-[0.8] text-stroke tracking-tighter select-none pointer-events-none">
          Peil
        </h2>
      </div>

      <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-brand-muted font-mono text-[10px] uppercase tracking-[0.15em]">
        <p>© {new Date().getFullYear()} Peil Consultancy Ltd. All rights reserved.</p>
        <p>{CONTACT.email}</p>
      </div>
    </div>
  </footer>
);

export default Footer;
